// src/features/filters/filtersSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clientFilters: {
    search: '',
    company: '',
    departureCity: '',
    minPrice: '',
    maxPrice: '',
    duration: '',
    category: '',
    zone: '',
    availability: false,
    page: 1,
  },
  adminFilters: {
    search: '',
    company: '',
    status: '',
    category: '',
    startDate: null,
    endDate: null,
    page: 1,
  },
  companyFilters: {
    search: '',
    status: '',
    page: 1,
  },
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    // Actions pour les filtres côté client
    setClientFilter: (state, action) => {
      const { name, value } = action.payload;
      state.clientFilters[name] = value;
      
      // Si on change un filtre, on revient à la page 1
      if (name !== 'page') {
        state.clientFilters.page = 1;
      }
    },
    resetClientFilters: (state) => {
      state.clientFilters = { ...initialState.clientFilters };
    },
    
    // Actions pour les filtres d'administration
    setAdminFilter: (state, action) => {
      const { name, value } = action.payload;
      state.adminFilters[name] = value;
      
      // Si on change un filtre, on revient à la page 1
      if (name !== 'page') {
        state.adminFilters.page = 1;
      }
    },
    resetAdminFilters: (state) => {
      state.adminFilters = { ...initialState.adminFilters };
    },
    
    // Actions pour les filtres de compagnies
    setCompanyFilter: (state, action) => {
      const { name, value } = action.payload;
      state.companyFilters[name] = value;
      
      // Si on change un filtre, on revient à la page 1
      if (name !== 'page') {
        state.companyFilters.page = 1;
      }
    },
    resetCompanyFilters: (state) => {
      state.companyFilters = { ...initialState.companyFilters };
    },
  },
});

export const {
  setClientFilter,
  resetClientFilters,
  setAdminFilter,
  resetAdminFilters,
  setCompanyFilter,
  resetCompanyFilters,
} = filtersSlice.actions;

export default filtersSlice.reducer;